import React from 'react';
import HomeGameSelection from '../scroll/slot_scroll_line.js';
import { useTranslation } from 'react-i18next';

function HomeScrollGames({ isLogged, onOpenLogin, casinoSections}) {
  const {t} = useTranslation();
  
  return (
    <div >
      {!casinoSections['casino'] ? <HomeGameSelection limit="10" selection_name={t('Slot')} category_id="casino" isLogged={isLogged} onOpenLogin={onOpenLogin}  /> : ''}
      {!casinoSections['casino-live'] ? <HomeGameSelection limit="10" selection_name={t('Casino_live')} category_id="casino-live" isLogged={isLogged} onOpenLogin={onOpenLogin}  /> : ''}
      {!casinoSections['crash_games'] ? <HomeGameSelection limit="10" selection_name={t('Crash_game')} category_id="crash-game" isLogged={isLogged} onOpenLogin={onOpenLogin}  /> : ''}
    </div>
  );
}

export default HomeScrollGames;
